module.exports = __webpack_public_path__ + "img/external-link.711a3668.svg";